import { createFileRoute } from '@tanstack/react-router';
import { CloseDayPage } from '@/features/close/pages/close-day-page';

export const Route = createFileRoute('/_app/close-day')({ component: CloseDayPage });
